import styled from 'styled-components';

const Title = styled.div`
  width: 100%;
  font-size: 16px;
`;

export default Title;
